import { useEffect } from 'react';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useConfirmEmail } from 'api';
import { LoadingScreen } from 'common/components';

import { AUTH_ROUTES } from '../routes';

const ConfirmEmailContainer = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';

  const { confirmEmail, isLoading } = useConfirmEmail(token);

  useEffect(() => {
    const doConfirmEmail = async () => {
      await confirmEmail();

      message.success(t('confirmEmail.success'));

      navigate(AUTH_ROUTES.login.to);
    };

    doConfirmEmail();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading) {
    return <LoadingScreen />;
  }

  return null;
};

export default ConfirmEmailContainer;
